import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { ProductForm } from "@/features/dashboard/produtos/components/ProductForm";

export const Route = createFileRoute("/_private/dashboard/_base/produtos/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  const { id } = Route.useParams();

  return (
    <BaseEditCreateModal title="Editar Produto" from="/dashboard/produtos/editar/$id">
      <ProductForm id={id} />
    </BaseEditCreateModal>
  );
}
